let navDropdownsBound = false;

// Manual open/close for the sidebar dropdown groups (Ads, Starred campaigns).
// Highlight + default-open state are server-rendered; this only handles clicks.
// Delegated on `document` and bound once so it survives Turbo navigations.
export function initNavDropdowns(): void {
  if (navDropdownsBound) return;
  navDropdownsBound = true;

  document.addEventListener('click', (e) => {
    const toggle = (e.target as HTMLElement).closest('[data-nav-toggle]');
    if (!toggle) return;
    const group = toggle.closest('.nav-group');
    if (!group) return;
    const open = group.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });
}

export function toggleMobileSidebar(): void {
  const $toggleBtn = $('#mobile-sidebar-toggle');
  const $closeBtn = $('#mobile-sidebar-close');
  const $backdrop = $('#mobile-sidebar-backdrop');
  const $sidebar = $('#mobile-sidebar');

  function openSidebar() {
    $sidebar.addClass('show');
    $('body').css('overflow', 'hidden');
  }

  function closeSidebar() {
    $sidebar.removeClass('show');
    $('body').css('overflow', '');
  }

  $toggleBtn.on('click', openSidebar);
  $closeBtn.on('click', closeSidebar);
  $backdrop.on('click', closeSidebar);

  const $sidebarHeaders = $('.sidebar-header[data-bs-toggle="collapse"]');
  $sidebarHeaders.on('click', function(e) {
    if ($(window).width() < 992) {
      e.preventDefault();
      const targetSelector = $(this).attr('data-bs-target');
      const $target = $(targetSelector);
      const $icon = $(this).find('i');

      if ($target.length) {
        if ($target.hasClass('show')) {
          $target.removeClass('show');
          $(this).attr('aria-expanded', 'false');
          if ($icon.length) $icon.css('transform', 'rotate(0deg)');
        } else {
          $target.addClass('show');
          $(this).attr('aria-expanded', 'true');
          if ($icon.length) $icon.css('transform', 'rotate(180deg)');
        }
      }
    }
  });

  $sidebar.find('a').on('click', function() {
    if ($(window).width() < 992) {
      setTimeout(closeSidebar, 200);
    }
  });
}
